import { render, staticRenderFns } from "./ListingSidebarBrandsFilter.vue?vue&type=template&id=6a85ba2c&scoped=true&"
import script from "./ListingSidebarBrandsFilter.vue?vue&type=script&lang=js&"
export * from "./ListingSidebarBrandsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ListingSidebarBrandsFilter.vue?vue&type=style&index=0&id=6a85ba2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85ba2c",
  null
  
)

export default component.exports